import React from 'react';
import { useTranslation } from 'react-i18next';
import ChevronRightIcon from 'components/atoms/icons/chevron-right';

import s from './styles.module.scss';

import type { ClinicLog } from 'infrastructure/classes/logs/clinic-log';

const FIELDS_WITH_HTML_VALUE = [
  'notes',
  'critical After Hours',
  'critical Business Hours',
];

interface IProps {
  data: ClinicLog;
}

const ChangesCol: React.FC<IProps> = ({ data }) => {
  const { t } = useTranslation();

  const renderValue = (value: string, field: string) => {
    if (!value || value === 'null') return t('labels.bannerNoData');

    if (FIELDS_WITH_HTML_VALUE.includes(field)) {
      return (
        <span
          className="ql-editor ql-index-1"
          dangerouslySetInnerHTML={{ __html: value }}
        />
      );
    }

    if (field === 'service Delivery Thresholds') {
      return Number(value) > 15
        ? `${Number(value) / 60} Hours`
        : `${value} minutes`;
    }

    return value;
  };

  return (
    <>
      {data.changes.map(({ field, from, to }, i) => (
        <div key={i} className={s.change}>
          <span className={s.date}>{field}</span>
          <div className={s.info}>
            <span className={s.from}>
              {t('labels.from')}: {renderValue(from, field)}
            </span>
            <ChevronRightIcon />
            <span className={s.to}>
              {t('labels.to')}: {renderValue(to, field)}
            </span>
          </div>
        </div>
      ))}
    </>
  );
};

export default ChangesCol;
